import { api } from '../../../lib/api';
import type { PublishingAccount } from '../../../types/publishing';
import type {
  SocialCommunity,
  SocialContent,
  SocialGbpPerformanceWindow,
  SocialGoogleBusiness,
  SocialOverview,
} from '../../../types/socialReporting';
import type { DateRange } from '../../../lib/reportingDateRange';

// Organic Social Reporting — client API. Thin wrappers over /api/reporting/social.

export async function listSocialReportingAccounts(): Promise<PublishingAccount[]> {
  const { accounts } = await api<{ accounts: PublishingAccount[] }>(
    '/api/reporting/social/accounts',
  );
  return accounts;
}

export function getSocialOverview(accountId: string, range: DateRange): Promise<SocialOverview> {
  const p = new URLSearchParams({ accountId, from: range.from, to: range.to });
  return api<SocialOverview>(`/api/reporting/social/overview?${p.toString()}`);
}

export function getSocialCommunity(accountId: string, range: DateRange): Promise<SocialCommunity> {
  const p = new URLSearchParams({ accountId, from: range.from, to: range.to });
  return api<SocialCommunity>(`/api/reporting/social/community?${p.toString()}`);
}

export function getSocialContent(accountId: string, range: DateRange): Promise<SocialContent> {
  const p = new URLSearchParams({ accountId, from: range.from, to: range.to });
  return api<SocialContent>(`/api/reporting/social/content?${p.toString()}`);
}

export function getSocialGoogleBusiness(
  accountId: string,
  range: DateRange,
): Promise<SocialGoogleBusiness> {
  const p = new URLSearchParams({ accountId, from: range.from, to: range.to });
  return api<SocialGoogleBusiness>(`/api/reporting/social/google-business?${p.toString()}`);
}

export function getSocialGbpPerformance(
  accountId: string,
  range: DateRange,
): Promise<SocialGbpPerformanceWindow> {
  const p = new URLSearchParams({ accountId, from: range.from, to: range.to });
  return api<SocialGbpPerformanceWindow>(
    `/api/reporting/social/google-business/performance?${p.toString()}`,
  );
}
